module.exports = __webpack_public_path__ + "static/media/TermsAndConditions.4d94ec84.pdf";